var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('navigator', 'userAgent') || '';



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/engine-user-agent.js
// module id = 45
// module chunks = 0 1